export default defineNuxtRouteMiddleware(async (to) => {
  if (!process.client) return
  const { $i18n } = useNuxtApp()
  const { t } = $i18n
  const { addNotification } = useNotifications()
  const sessionVoucherStore = useSessionVoucherStore()

  const query = to?.query
  const sessionVoucher = query?.c

  if (sessionVoucherStore.voucherCode && !sessionVoucher) {
    await sessionVoucherStore.validateVoucher(sessionVoucherStore.voucherCode)
    const discountAmount = sessionVoucherStore.getDiscountAmount(
      sessionVoucherStore.voucherData!
    )

    const notificationMessage = t('checkout.sessionVoucher.reminderMessage', {
      amount: discountAmount,
    })

    if (discountAmount) {
      await addNotification({
        type: 'SUCCESS',
        message: notificationMessage,
        showIcon: true,
        persist: true,
      })
    }

    return
  }

  if (sessionVoucher) {
    try {
      await sessionVoucherStore.validateVoucher(sessionVoucher.toString())

      const discountAmount = sessionVoucherStore.getDiscountAmount(
        sessionVoucherStore.voucherData!
      )

      const successMessage =
        sessionVoucherStore.voucherData?.success_message ||
        t('checkout.sessionVoucher.successMessage', {
          amount: discountAmount,
        })

      if (discountAmount) {
        await addNotification({
          type: 'SUCCESS',
          message: successMessage,
          showIcon: true,
          persist: true,
        })
      }
    } catch (e) {
      const message = e?.data?.message || t('cart.sessionVoucher.errorMessage')
      await addNotification({
        type: 'ERROR',
        message,
        showIcon: true,
      })
    }
  }
})
